export default __webpack_public_path__ + "static/media/validation_green.e2d340e6.svg";